import SubscriptionInvoiceHistory from "../../components/SubscriptionInvoiceHistory.jsx";
import { useEffect, useState } from "react";
import { api } from "../../api.js";
import Card from "../../components/common/Card.jsx";
import PageTitle from "../../components/common/PageTitle.jsx";
import { useAuth } from "../../context/AuthContext.jsx";

export default function ProfileSettingsPage({ mode = "profile", notify }) {
  const { logout,user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", password: "",currentPassword:"" });
  useEffect(() => {
    api("/auth/profile").then((data) => {
      setProfile(data);
      setForm({ name: data.name, email: data.email, password: "",currentPassword:"" });
    });
  }, []);
  async function submit(event) {
    event.preventDefault();
    await api("/auth/profile", { method: "PATCH", body: JSON.stringify(form) });
    notify("Profile updated. Login again to refresh account details");
    window.setTimeout(logout, 1200);
  }
  if (!profile) return null;
  if (mode === "details")
    return (
      <>
        <PageTitle
          title="Account Details"
          subtitle="SaaS owner identity and access information"
        />
        <Card>
          <dl className="account-details">
            <div>
              <dt>Name</dt>
              <dd>{profile.name}</dd>
            </div>
            <div>
              <dt>Email</dt>
              <dd>{profile.email}</dd>
            </div>
            <div>
              <dt>Role</dt>
              <dd>{profile.role}</dd>
            </div>
            <div>
              <dt>Status</dt>
              <dd>{profile.active ? "Active" : "Disabled"}</dd>
            </div>
            <div>
              <dt>Created</dt>
              <dd>{new Date(profile.createdAt).toLocaleString()}</dd>
            </div>
          </dl>
        </Card>
      </>
    );
  return (
    <>
      <PageTitle
        title={mode === "settings" ? "Owner Settings" : "Profile Settings"}
        subtitle="Update owner name, email and secure password"
      />
      <Card>
        <form className="owner-user-form" onSubmit={submit}>
          <label>
            <span>Name</span>
            <input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </label>
          <label>
            <span>Email</span>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </label>
          <label><span>Current password when changing password</span><input type="password" autoComplete="current-password" value={form.currentPassword||''} onChange={e=>setForm({...form,currentPassword:e.target.value})}/></label>
            <label>
            <span>New Password (optional)</span>
            <input
              type="password"
              minLength="12"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </label>
          <button className="primary">Save Profile</button>
        </form>
      </Card>
      {(["company_owner","company_admin","admin"].includes(user?.role)||(user?.permissions||[]).includes("billing.manage"))&&<SubscriptionInvoiceHistory/>}
    </>
  );
}
